export enum CrudStoreItem {
  UniqueSupervisors = 'UniqueSupervisors',
  AccessRequestStatus = 'AccessRequestStatus',
}
